<template>
  <div class="pa-action-confirm">
    <transition name="pa-simple-fade" @afterLeave="handleAfterLeaveContent">
      <div class="content-field" :class="contentFieldClass" v-if="isOpenContent">
        <template v-if="isLoading">
          <PuffLoadingImage stroke="#957E63" />
        </template>
        <template v-else>
          <div class="message-field message-field-minify">
            <p>{{message}}</p>
            <ul>
              <li>
                <button
                class="button pa-button pa-button-danger"
                :class="confirmButtonClass"
                :disabled="isDisabledConfirmButton"
                @click.prevent="handleClickConfirmButton"
                >{{confirmButtonText}}</button>
              </li>
              <li>
                <button
                class="button pa-button pa-button-clear"
                :class="cancelButtonClass"
                :disabled="isDisabledCancelButton"
                @click.prevent="handleClickCancelButton"
                >{{cancelButtonText}}</button>
              </li>
            </ul>
          </div>
        </template>
      </div>
    </transition>

    <transition name="message-action-confirm-overlay" @afterEnter="handleAfterEnterOverlay">
      <div class="overlay-field" v-if="isOpenOverlay"></div>
    </transition>
  </div>
</template>

<script>
import PuffLoadingImage from '@/components/Pages/Connections/ConnectionApp/Images/puff.svg?inlineN'

export default {
  props : {
    isOpen : {
      default : false
    },

    isLoading : {
      default: false
    }
  },

  components : {
    PuffLoadingImage
  },

  data(){
    return {
      isOpenContent           : false,
      isOpenOverlay           : false,

      contentFieldClass       : [],

      message                 : 'このメッセージを削除しますか？',

      confirmButtonText       : '削除',
      isDisabledConfirmButton : false,
      confirmButtonClass      : [],
      
      cancelButtonText        : 'やめる',
      isDisabledCancelButton  : false,
      cancelButtonClass       : [],
    };
  },

  watch : {
    isOpen(value){
      if(value === true){
        this.isOpenOverlay = true;
      }else{
        this.isOpenContent = false;
      }
    }
  },

  methods : {
    handleAfterLeaveContent(){
      this.isOpenOverlay = false;
    },

    handleAfterEnterOverlay(){
      this.isOpenContent = true;
    },

    handleClickConfirmButton(){
      this.$emit('handleSubmit');
    },

    handleClickCancelButton(){
      this.$emit('handleCancel');
    }
  }
}
</script>

<style lang="scss">
@keyframes messageActionBlur
{
  0%   {
    opacity:0;
    backdrop-filter: blur(0px);
  }
  100% {
    backdrop-filter: blur(3px) opacity(.9);
    opacity:.7;
  }
}

.message-action-confirm-overlay{
  &-enter-active{
    animation: messageActionBlur .5s;
  }

  &-leave-active {
    animation: messageActionBlur .5s reverse;
  }

  &-enter, &-leave-to{
    opacity: 0;
  }
}

.pa-action-confirm{
  .content-field{
    position:absolute;
    z-index:1000;
    top:0;
    left:0;
    width:100%;
    height:100%;

    z-index:1001;
    display:flex;
    justify-content: center;
    align-items: center;
    text-align:center;

    .message-field{
      > p{
        color:#533B2A;
        font-size:1.3rem;
        margin-bottom:.5rem;
      }

      ul{
        display:flex;
        flex-direction: row;
        justify-content: center;

        li{
          margin-right:1.2rem;

          &:last-child{
            margin-right:0;
          }

          .pa-button{
            padding:0 2rem;
            font-size:.8rem;
            height:auto;
            line-height:2;
            border:2px solid #A2856B;

            &-danger{
              border-color:#BF698D !important;
              background-color:#B76084;
              border-color:#D76897 !important;
              background-color:#D06A95;
            }

            &-clear{
              padding:0 1.5rem;
              border-color:#A2856B !important;
              background-color:#A88D74;
            }
          }
        }
      }

      &-minify{
        > p{
          font-size:1rem;
          margin-bottom:.4rem;
        }

        ul{
          li{
            margin-right:.8rem;

            .pa-button{
              padding:0 1.2rem;
              font-size:.7rem;
              height:auto;
              line-height:1.6;
              border:1px solid #A2856B;

              &-clear{
                padding:0 1rem;
              }
            }
          }
        }
      }
    }
  }

  .overlay-field{
    position:absolute;
    z-index:1000;
    top:0;
    left:0;
    width:100%;
    height:100%;

    background:radial-gradient(#bda381 10%, #cab090);
    backdrop-filter: blur(3px) opacity(.9);
    opacity:.7;
  }
}
</style>